module.exports = __webpack_public_path__ + "media/images/give-with-food-3f47e9f37fe7facc721fd03eb5e8a15f.svg";